module.exports = __webpack_public_path__ + "img/rsz_1image_from_ios.78711112.png";